import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiCheckCircle, FiArrowLeft, FiTerminal } from 'react-icons/fi';
import Footer from '../../components/Footer';
import ConsultationForm from '../../components/ConsultationForm';

/**
 * Reusable service detail page layout — dark/rainbow aesthetic.
 * Props: color, icon, title, tagline, heroDescription, features[], useCases[], techStack[], slug
 */
export default function ServiceTemplate({
  color, icon, title, tagline, heroDescription,
  features = [], useCases = [], techStack = [], slug,
}) {
  return (
    <div className="con-page" style={{ '--svc-color': color }}>
      {/* Hero */}
      <section className="con-svcdet-hero">
        <div className="con-container">
          <Link to="/consulting" className="con-back-link"><FiArrowLeft /> All Services</Link>
          <div className="con-svcdet-hero-inner">
            <div className="con-svcdet-icon" style={{ color, borderColor: `${color}33` }}>{icon}</div>
            <h1 style={{ color }}>{title}</h1>
            <p className="con-svcdet-tagline">{tagline}</p>
            <p className="con-svcdet-desc">{heroDescription}</p>
            <div className="con-hero-actions">
              <a href="#consultation" className="con-btn-primary" style={{ background: color, borderColor: color }}>
                Start Your Consultation <FiArrowRight />
              </a>
              <Link to="/consulting" className="con-btn-ghost">
                View All Services
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="con-svcdet-features">
        <div className="con-container">
          <div className="con-section-head">
            <span className="con-overline" style={{ color }}>Capabilities</span>
            <h2>What We Deliver</h2>
          </div>
          <div className="con-svcdet-feat-grid">
            {features.map((f, i) => (
              <div className="con-svcdet-feat-card" key={i}>
                <div className="con-svcdet-feat-num" style={{ color }}>{String(i + 1).padStart(2, '0')}</div>
                <h3>{f.title}</h3>
                <p>{f.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Use Cases */}
      {useCases.length > 0 && (
        <section className="con-svcdet-usecases">
          <div className="con-container">
            <div className="con-section-head">
              <span className="con-overline" style={{ color }}>Use Cases</span>
              <h2>Real-World Applications</h2>
            </div>
            <div className="con-svcdet-uc-grid">
              {useCases.map((uc, i) => (
                <div className="con-svcdet-uc-card" key={i}>
                  <h3>{uc.title}</h3>
                  <p>{uc.description}</p>
                  <div className="con-svcdet-uc-result">
                    <FiCheckCircle style={{ color }} />
                    <span>{uc.result}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Tech Stack */}
      {techStack.length > 0 && (
        <section className="con-svcdet-tech">
          <div className="con-container">
            <div className="con-section-head">
              <span className="con-overline" style={{ color }}>Technology</span>
              <h2>Tools & Platforms We Work With</h2>
            </div>
            <div className="con-svcdet-tech-grid">
              {techStack.map((t) => (
                <div className="con-svcdet-tech-chip" key={t} style={{ borderColor: `${color}44` }}>
                  <FiTerminal style={{ color, fontSize: '0.7rem' }} /> {t}
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Consultation Onboarding Form */}
      <section className="con-svcdet-form" id="consultation">
        <div className="con-container">
          <div className="con-section-head">
            <span className="con-overline" style={{ color }}>Get Started</span>
            <h2>Request Your Free Consultation</h2>
            <p>Answer a few quick questions so we can match you with the right specialist.</p>
          </div>
          <ConsultationForm serviceSlug={slug} color={color} />
        </div>
      </section>

      <Footer />
    </div>
  );
}
